const React = require('react');
const SwitchC = require('./C');


module.exports = (props) => {
  return (
    <SwitchC
      {...props}
      className={'fw7>.SwitchC_Label ' + (props.className || '')}
    />
  );
};
